module.exports = __webpack_public_path__ + "static/media/textediter_list_active.05f9071c.svg";